module.exports = __webpack_public_path__ + "img/customer@2x.1c9cf5cf.jpg";